import { FilterMatchMode } from 'primereact/api';
import { Tag } from 'primereact/tag';
import { Badge } from 'primereact/badge';

export class ConfiguracionAlerta {
    constructor() {
        this.model = {
            orden: {
                header: '#',
                table: true,
                sort: true,
                filter: false,
                style: { minWidth: '50px', textAlign: 'center', fontSize: '0.8rem' },
                body: (rowData) => <span className="text-500">#{rowData.orden}</span>
            },
            nombre: {
                header: 'Alerta',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '200px' },
                body: (rowData) => (
                    <div className="flex flex-column">
                        <span className="font-bold text-900" style={{ fontSize: '0.9rem' }}>{rowData.nombre}</span>
                    </div>
                )
            },
            prioridad: {
                header: 'Nivel de Alerta',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '140px' },
                body: (rowData) => {
                    const config = {
                        'NIVEL_ALERTA_CRITICA': { sev: 'danger', icon: 'pi pi-exclamation-triangle', cls: 'tag-critica' },
                        'NIVEL_ALERTA_ESTANDAR': { sev: 'warning', icon: 'pi pi-exclamation-circle', cls: '' },
                        'NIVEL_ALERTA_BAJA': { sev: 'info', icon: 'pi pi-info-circle', cls: '' },
                        'NIVEL_NO_ALERTA': { sev: 'success', icon: 'pi pi-check-circle', cls: '' }
                    };
                    const res = config[rowData.prioridad_nemonico] || { sev: 'info', icon: 'pi pi-bell', cls: '' };

                    return (
                        <Tag value={rowData.prioridad.toUpperCase()} severity={res.sev} icon={res.icon} className={res.cls} style={{ fontSize: '0.7rem', borderRadius: '4px', padding: '0.3rem 0.5rem' }} />
                    );
                }
            },
            menu_nombre: {
                header: 'Módulo',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '150px' },
                body: (rowData) => (
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-folder text-primary" style={{ fontSize: '0.8rem' }}></i>
                        <span style={{ fontSize: '0.9rem' }}>{rowData.menu_nombre}</span>
                    </div>
                )
            },
            total: {
                header: 'Pendientes',
                table: true,
                sort: true,
                filter: false,
                isNumeric: true,
                style: { minWidth: '100px', textAlign: 'center' },
                body: (rowData) => {
                    return (
                        <div className="flex align-items-center justify-content-center">
                            <Badge value={rowData.total} severity={rowData.total > 10 ? 'danger' : rowData.total > 0 ? 'warning' : 'success'} style={{ minWidth: '2rem', height: '2rem', lineHeight: '2rem' }} />
                        </div>
                    );
                }
            }
        };
    }
}